<script setup lang="ts">
  import { computed } from 'vue'
  import CommonLoginModal from '@common/auth-layer/components/LoginModal.vue'
  import { useAuth } from '@common/auth-layer/composables/useAuth'
  import { useLocation } from '@common/location-layer/composables/useLocation'

  const { t } = useI18n()
  const { store: locationStore } = useLocation()
  const { handleRedirectAfterLogin } = useAuth()
  const brandLogo = computed(() => {
    const branding = locationStore.branding
    if (!branding) return null
    return (
      branding.portalIcon ||
      branding.logo ||
      branding.portalImage ||
      branding.portalBannerImage ||
      branding.bannerImage ||
      branding.favicon ||
      null
    )
  })
  const brandName = computed(() => {
    return locationStore.branding?.portalBannerText || t('auth.branding.defaultPortalName')
  })
  const onLoginSuccess = async () => {
    await handleRedirectAfterLogin()
  }

  defineOptions({
    name: 'ClientportalLoginModal',
  })
</script>

<template>
  <CommonLoginModal :brand-logo="brandLogo" :brand-name="brandName" @login-success="onLoginSuccess" />
</template>
